const isIOS = () => {
  return !!(navigator.userAgent.match(/(ipad|IPAD|iPad|iPhone|iphone|IPHONE|iPod|ipod|IPOD)/g));
}

export default isIOS;
